import { Immutable } from "immer";
import React from "react";

import type { PromoConditionalBlock as Value } from "@reactivated";

type Props = Immutable<{
    value: Value;
    children?: React.ReactNode;
}>;

/**
 * PromoConditionalBlock is a thin wrapper that conditionally renders its
 * children based on the server-computed `is_promo_active` flag exposed by the
 * `PromoPeriod` snippet's `get_data_for_client_render`.
 *
 * The site-specific content StreamField is rendered by the per-site assembly
 * (Phase 2 / #33583) and passed in as `children`.
 *
 * NOTE: Preserves the historical typo class name `promo-condtional-block`
 * (missing 'i') used by the existing Django template and downstream styles.
 */
export const PromoConditionalBlock = (
    props: Props,
): React.JSX.Element | null => {
    if (!props.value.promo_period?.is_promo_active) {
        return null;
    }
    return <div className="promo-condtional-block">{props.children}</div>;
};
